/* eslint-disable */
"use strict";

var config, service;
(async () => {
  const response = await fetch(process.env.BASE_URL + "config.json");
  config = await response.json();
  service = config.service_ingenico || process.env.VUE_APP_service_ingenico;
})();

async function richiestaStato(terminale) {
  const data = {
    payload: {
      tml: terminale.tml,
      ip: terminale.ip,
      porta: terminale.porta,
    },
  };
  const response = await fetch(`${service}/richiestaStato`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return await response.json();
}

async function richiestaPagamento(terminale, importo) {
  // return { status: 'ok' }
  try {
    const data = {
      payload: {
        tml: terminale.tml,
        ip: terminale.ip,
        porta: terminale.porta,
        payment: {
          amount: importo,
        },
      },
    };
    const response = await fetch(`${service}/richiestaPagamento`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (err) {
    return { error: true, message: "Servizio POS non raggiungibile" };
  }
}

async function getStatoOperazione() {
  // return { tipo: 'operazione', messaggio: 'operazione annullata' }
  // TODO: Verificare se è necessario specificare il terminale nel caso di più dispositivi
  try {
    const response = await fetch(`${service}/getStatoOperazione`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
    return await response.json();
  } catch (err) {
    return {
      error: true,
      message: err.message,
      tipo: "operazione",
      operazione: "Servizio POS non raggiungibile",
    };
  }
}

async function resetConnessione(terminale) {
  try {
    const data = {
      payload: {
        tml: terminale.tml,
        ip: terminale.ip,
        porta: terminale.porta,
      },
    };
    const response = await fetch(`${service}/reset`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (err) {
    return {
      error: true,
      message: err.message,
      tipo: "operazione",
      operazione: "Servizio POS non raggiungibile",
    };
  }
}

export default {
  richiestaStato,
  richiestaPagamento,
  getStatoOperazione,
  resetConnessione,
};
